/*=========================================================================================
  File Name: actions.js
  Description: Vuex Store - actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import localStorageHelper from "../helpers/local-storage-helper"

const actions = {

    // /////////////////////////////////////////////
    // COMPONENTS
    // /////////////////////////////////////////////

    // Vertical NavMenu
    updateVerticalNavMenuWidth({ commit }, width) {
      commit('UPDATE_VERTICAL_NAV_MENU_WIDTH', width)
    },

    // VxAutoSuggest
    updateStarredPage({ commit }, payload) {
      commit('UPDATE_STARRED_PAGE', payload)
    },

    // The Navbar
    arrangeStarredPagesLimited({ commit }, list) {
      commit('ARRANGE_STARRED_PAGES_LIMITED', list)
    },
    arrangeStarredPagesMore({ commit }, list) {
      commit('ARRANGE_STARRED_PAGES_MORE', list)
    },

    // /////////////////////////////////////////////
    // UI
    // /////////////////////////////////////////////

    toggleContentOverlay({ commit }) {
      commit('TOGGLE_CONTENT_OVERLAY')
    },
    updateTheme({ commit }, val) {
      commit('UPDATE_THEME', val)
    },

    // /////////////////////////////////////////////
    // TICKER
    // /////////////////////////////////////////////
    canDisplayTicker({ commit }, val) {
      commit('UPDATE_CAN_DISPLAY_TICKER', val)
    },
    setDisplayTicker({ commit }, val) {
      commit('SET_CAN_DISPLAY_TICKER', val)
    },
    tickerViewAtTheTop({ commit }, val) {
      commit('UPDATE_TICKER_VIEW_AT_THE_TOP', val)
    },
    setTickerViewAtTheTop({ commit }, val) {
      commit('SET_TICKER_VIEW_AT_THE_TOP', val)
    },
    viewImportantTickers({ commit }, val) {
      commit('UPDATE_VIEW_IMPORTANT_TICKERS', val)
    },
    viewHighlightsTickers({ commit }, val) {
      commit('UPDATE_VIEW_HIGHLIGHTS_TICKERS', val)
    },

    // /////////////////////////////////////////////
    // BIOMETRY
    // /////////////////////////////////////////////
    updateBiometry({ commit }, payload) {
      commit('UPDATE_BIOMETRY', payload);
    },

    // /////////////////////////////////////////////
    // User/Account
    // /////////////////////////////////////////////

    updateUserInfo({ commit }, payload) {
      commit('UPDATE_USER_INFO', payload)
    },

    // /////////////////////////////////////////////
    // Report List Style
    // /////////////////////////////////////////////

    reportListStyle({ commit }, payload) {
      commit('UPDATE_REPORT_VIEW_STYLE', payload)
    },

    // /////////////////////////////////////////////
    // PLAYLIST
    // /////////////////////////////////////////////

    insertItemPlaylist({ commit }, payload) {
      commit('INSERT_PLAYLIST', payload)
    },
    removeItemPlaylist({ commit }, payload) {
      commit('REMOVE_PLAYLIST', payload)
    },
    clearPlaylist({ commit }, payload) {
      commit('CLEAR_PLAYLIST', payload);
      commit('PLAYLIST_REMOVE_ITEM_SELECTED', payload);
    },
    addPlaylistItemSelected({ commit }, payload) {
      commit('PLAYLIST_ADD_ITEM_SELECTED', payload)
    },
    removePlaylistItemSelected({ commit }, payload) {
      commit('PLAYLIST_REMOVE_ITEM_SELECTED', payload)
    },
    updateSubscribeToolsVisibility({ commit }, payload) {
      commit('UPDATE_SUBSCRIBETOOLS_VISIBILITY', payload)
    },
    updateNavMenuVisibility({ commit }, payload) {
      commit('UPDATE_NAVMENU_VISIBILITY', payload)
    },
    initFavoriteMenuContentData({ commit }, payload) {
      commit('INIT_FAVORITE_CONTENT_DATA', payload);
    },
    updateFavoriteMenuContent({ commit }, payload) {
      commit('UPDATE_FAVORITE_CONTENT', payload);
    },
    updateCurrentFilter({ commit }, payload) {
      commit('UPDATE_CURRENT_FILTER', payload);
    },

    // /////////////////////////////////////////////
    // COMMODITY
    // /////////////////////////////////////////////
    updateCurrentCommodity({ commit }, payload) {
      commit('UPDATE_CURRENT_COMMODITY', payload);
    },
    updateCurrentContent({ commit }, payload) {
      commit('UPDATE_CURRENT_CONTENT', payload);
    },
    updateCurrentContentToDefault({ commit }, payload) {
      commit('UPDATE_CURRENT_CONTENT_TO_DEFAULT', payload);
    },
    updateCurrentReportType({ commit }, payload) {
      commit('UPDATE_CURRENT_REPORT_TYPE', payload);
    },

    // /////////////////////////////////////////////

    updateUserAuthenticated({ commit }, payload) {
      commit('UPDATE_USER_AUTHENTICATED', payload);
    },
    updateRateTextSpeech({ commit }, payload) {
      commit('UPDATE_RATE_TEXT_SPREECH', payload);
    },
    updateIsPausedTextSpeech({ commit }, payload) {
      commit('UPDATE_ISPAUSED_TEXT_SPREECH', payload);
    },
    updateIsPlayingTextSpeech({ commit }, payload) {
      commit('UPDATE_ISPLAYING_TEXT_SPREECH', payload);
    },

    updateSubjectMenu({ commit }, payload) {
      commit('UPDATE_SUBJECT_MENU', payload);
    },

    updateCurrentMedia({ commit }, payload) {
      commit('UPDATE_CURRENT_MEDIA', payload);
    },

    updateYoutubeCurrentTime({ commit }, payload) {
      commit('UPDATE_YOUTUBE_CURRENT_TIME', payload);
    },
    updateAuioCurrentTime({ commit }, payload) {
      commit('UPDATE_AUDIO_CURRENT_TIME', payload);
    },
    updatePlaylistOpen({ commit }, payload) {
      commit('UPDATE_PLAYLIST_OPEN', payload);
    },
    updateYoutubeIsPlaying({ commit }, payload) {
      commit('UPDATE_YOUTUBE_ISPLAYING', payload);
    },
    updateAudioIsPlaying({ commit }, payload) {
      commit('UPDATE_AUDIO_ISPLAYING', payload);
    },
    updateZoom({ commit }, payload) {
      commit('UPDATE_ZOOM', payload);
    },
    updateZoomDetail({ commit }, payload) {
      commit('UPDATE_ZOOM_DETAIL', payload);
    },
    updateFormatAlignDetail({ commit }, payload) {
      commit('UPDATE_FORMAT_ALIGN_DETAIL', payload);
    },
    updateLatestMedia({ commit }, payload) {
      commit('UPDATE_LATEST_MEDIA', payload);
    },
    updateContentPrivate({ commit }, payload) {
      commit('UPDATE_CONTENT_PRIVATE', payload);
    },
    updateQuotesPublic({ commit }, payload) {
      commit('UPDATE_QUOTES_PUBLIC', payload);
    },
    updateFilterUsers({ commit }, payload) {
      commit('UPDATE_FILTER_USERS', payload);
    },
    updateRefreshActive({ commit }, payload) {
      commit('UPDATE_REFRESH_ACTIVE', payload);
    },
    updateContentSubmenuReduceSidebar({ commit }, payload) {
      commit('UPDATE_CONTENT_SUBMENU_REDUCE_SIDEBAR', payload);
    },
    updateMobileIos({ commit }, payload) {
      commit('UPDATE_MOBILE_IOS', payload);
    },

    setNotification({ commit }, payload) {
      commit('SET_NOTIFICATION', payload);
    },
    updateNotification({ commit }, payload) {
      commit('UPDATE_NOTIFICATION', payload);
    },

    setScheduleData({ commit }, payload) {
      commit('SET_SCHEDULE_DATA', payload);
    },
    insertScheduleData({ commit }, payload) {
      commit('INSERT_SCHEDULE_DATA', payload);
    },
    removeScheduleData({ commit }, payload) {
      commit('REMOVE_SCHEDULE_DATA', payload);
    },
    clearScheduleData({ commit }, payload) {
      commit('CLEAR_SCHEDULE_DATA', payload);
    },
    updateQuotesContentList({ commit }, payload) {
      commit('UPDATE_QUOTES_CONTENT_LIST_DATA', payload);
    },

    updateBiometrySecrets({ commit }, payload) {
      localStorageHelper.updateBiometrySecrets(payload);
      commit('UPDATE_BIOMETRY_SECRETS', payload);
    },
    updateHasBiometry({ commit }, payload) {
      localStorageHelper.updateHasBiometry(payload);
      commit('UPDATE_HAS_BIOMETRY', payload);
    },
    updateIsBiometryAvailable({ commit }, payload) {
      localStorageHelper.updateIsBiometryAvailable(payload);
      commit('UPDATE_IS_BIOMETRY_AVAILABLE', payload);
    },
    updateBiometrySecretsStatus({ commit }, payload) {
      localStorageHelper.updateBiometrySecretsStatus(payload);
      commit('UPDATE_BIOMETRY_SECRETS_STATUS', payload);
    },
    updateBiometryType({ commit }, payload) {
      localStorageHelper.updateBiometryType(payload);
      commit('UPDATE_BIOMETRY_TYPE', payload);
    },
    updateOnLogin({ commit }, payload) {
      commit('UPDATE_ON_LOGIN', payload);
    },
    updateCorrelationId({ commit }, payload) {
      commit('UPDATE_CORRELATION_ID', payload);
    },
    updateHighlightCollapsed({ commit }, payload) {
      commit('UPDATE_HIGHLIGHT_COLLAPSED', payload);
    },
    updateInsetTop({ commit }, payload) {
      commit('UPDATE_INSET_TOP', payload);
    },
    updateInsetBottom({ commit }, payload) {
      commit('UPDATE_INSET_BOTTOM', payload);
    },
    updateInsetLeft({ commit }, payload) {
      commit('UPDATE_INSET_LEFT', payload);
    },
    updateInsetRight({ commit }, payload) {
      commit('UPDATE_INSET_RIGHT', payload);
    },


}

export default actions
